import { HERO_HEADLINE } from './heroHeadlineTest';

/** Visible `<h1>` on `/pricing` (React + prerender static copy). */
export const PRICING_PAGE_HEADLINE = 'Start free. Upgrade when you need more.';

/** Visible `<h1>` on `/proof` (React + prerender static copy). */
export const PROOF_PAGE_HEADLINE = 'Every week in the model portfolio.';

/** Visible `<h1>` on `/about` (React + prerender static copy). */
export const ABOUT_PAGE_HEADLINE = 'We built the thing we wished existed.';

/** Visible `<h1>` on `/method` (React + prerender static copy). The amount matches DEFAULT_AMOUNT. */
export const METHOD_PAGE_HEADLINE = 'Follow $10,000 through the method.';

/** Static prerender `<h1>` on `/open-portfolio` (React uses amount-dependent `#op-headline`). */
export const OPEN_PORTFOLIO_STATIC_PRERENDER_HEADLINE = 'Open Portfolio scoreboard';

/**
 * React page `<h1>` text for each build-time prerender route.
 * Used to keep `routeMeta` static bodies aligned with live pages.
 */
export const REACT_H1_BY_PRERENDER_ROUTE: Record<string, string> = {
  '/': HERO_HEADLINE,
  '/about': ABOUT_PAGE_HEADLINE,
  '/blog': 'Our Blog: Insights & Updates',
  '/pricing': PRICING_PAGE_HEADLINE,
  '/proof': PROOF_PAGE_HEADLINE,
  '/quiz': 'How big a drop can you live with?',
  '/for/diy': 'Built for DIY investors.',
  '/method': METHOD_PAGE_HEADLINE,
  '/tools': 'Tools for clear-eyed DIY work.',
  '/tools/fee-drag': 'Fee drag calculator',
  '/vs/robo-advisors': 'QInvesting vs robo-advisors',
  '/vs/stock-pickers': 'QInvesting vs stock pickers & newsletters',
  '/privacy': 'Privacy',
  '/terms': 'Terms',
  '/disclosures': 'Disclosures',
};
